var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7086 13.5905L10.5101 16.3825C10.7941 16.3825 10.9171 16.2605 11.0646 16.114L12.3961 14.8415L15.1551 16.862C15.6611 17.144 16.0176 16.9955 16.1541 16.3965L17.9651 7.91046L17.9656 7.90996C18.1261 7.16196 17.6951 6.86946 17.2021 7.05296L6.55709 11.1285C5.83059 11.4105 5.84159 11.8155 6.43359 11.999L9.15509 12.8455L15.4766 8.88996C15.7741 8.69296 16.0446 8.80196 15.8221 8.99896L10.7086 13.5905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.7a05f1c32f3e1ad3c94e2d47424d126d.svg";
export { ForwardRef as ReactComponent };